import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { parseWebAPIErrors } from 'src/app/shared/Errors/parseWebAPIErrors';
import { IIndexCoupon, IIndexOrder } from 'src/app/shared/Models/IOrder';
import { IIndexShipping, IShipping } from 'src/app/shared/Models/IShipping';
import { IUser } from 'src/app/shared/Models/IUser';
import { IExtendPagination, PaginatedResult } from 'src/app/shared/Pagination/IPagination';
import { CustomerService } from 'src/app/shared/services/Customer.service';
import { IMarket, MarketService } from 'src/app/shared/services/market.service';
import { OrderService } from 'src/app/shared/services/order.service';
import { ShippingService } from 'src/app/shared/services/shipping.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-onlineMarket',
  templateUrl: './onlineMarket.component.html',
  styleUrls: ['./onlineMarket.component.scss']
})
export class OnlineMarketComponent implements OnInit {

  shippings$: Observable<PaginatedResult<IIndexShipping[]>>;



  buyerId = '';
  isUrlOpenByLink = false;
  totalCount = 0;
  showCalc = false;

  currentPage: number = 1;
  pageSize: number = 24;
  orderBy: string = 'ShippingStatus';


  height = 0;
  width = 0;
  length = 0;


  productImages: File[] = [];
  imagesUrls: string[] = [];




  year = new Date();
  fromStartYearDate = new FormControl(new Date(this.year.getFullYear(), 0, 1));
  getCurrentDay = this.year.getDay() + 3;
  toStartYearDate = new FormControl(new Date());


  todayNumber: number = Date.now();
  todayDate: Date = new Date();
  todayString: string = new Date().toDateString();
  startDate: string;
  endDate: string;
  maxDate: string;

  pagination: IExtendPagination;

  public openWebsite: boolean = false;
  public openNewOrder: boolean = true;
  public openOrders: boolean = false;


  isCouponApplied = false;
  couponDisabled = false;
  usedCouponName = "";
  coupons$: Observable<IIndexCoupon>;
  @ViewChild("couponQuery") couponInput: ElementRef<HTMLInputElement>;


  _openClassToggle = true;
  onlineShoppingForm: FormGroup;


  orders: any[] = [];


  error_messages = {

    productName: [
      { type: 'required', message: 'product Name is required.' },
      { type: 'minlength', message: 'product Name length must be bigger than 3.' },
    ],
    link: [
      { type: 'required', message: 'Link  is required.' }
    ],
    quantity: [
      { type: 'required', message: 'Quantity is required.' }
    ],
    itemPrice: [
      { type: 'required', message: 'Item Price is required.' }
    ],
    weight: [
      { type: 'required', message: 'Weight is required.' },
      { type: 'min', message: 'Minimum pound is 1 lbs.' },
    ],

  };






  get getProductName() {
    return this.onlineShoppingForm.get('productName');
  }

  get getLink() {
    return this.onlineShoppingForm.get('link');
  }


  get getQuantity() {
    return this.onlineShoppingForm.get('quantity');
  }


  get getItemPrice() {
    return this.onlineShoppingForm.get('itemPrice');
  }




  get getWeight() {
    return this.onlineShoppingForm.get('weight');
  }





  markets$: Observable<IMarket[]>;




  constructor(
    private _orderService: OrderService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _shippingService: ShippingService,
    private datePipe: DatePipe,
    private _marketService: MarketService,
    private _toastrService: ToastrService,
    private toastrService: ToastrService
  ) {

    this.markets$ = this._marketService.getMarkets$;


    const dateFormat = 'yyyy-MM-dd';
    var date = new Date();
    var year = date.getFullYear();
    var startYear = new Date(year, 0, 1);
    this.startDate = datePipe.transform(startYear, dateFormat);
    this.maxDate = datePipe.transform(new Date(), dateFormat);
    this.maxDate = this.endDate = datePipe.transform(new Date(), dateFormat);

    // this.fromStartYearDate   = getProject.dateOfStart.slice(0, 10).split('-').reverse().join('/'); // yyyy-MM-dd
    this.fromStartYearDate.setValue(this.startDate);




  }


  isUerLogin() {
    var user: IUser = JSON.parse(localStorage.getItem('user'));

    if (!user) {
      return false;
    } else {
      return true;
    }
  }


  ngOnInit(): void {


    this.openWebsite = false;
    this.openNewOrder = true;
    this.openOrders = false;
    this._openClassToggle = false;


    var user: IUser = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      this._toastrService.warning("Please Login");
      return;
    }


    this.pagination = {
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      buyerId: user.id,
    };


    this._shippingService.searchShipping(this.pagination).subscribe((data) => {
      if (!data) {
        return;
      }

      this.totalCount = data.pagination.totalCount;
      this.pagination = data.pagination;
    });


    this.shippings$ = this._shippingService.getShippings$

    this.shippings$.subscribe((data) => {

      if (!data) {
        return;
      }




    })



    this.onlineShoppingForm = this._formBuilder.group({

      productName: [null,
        [
          Validators.required,
          Validators.minLength(3)
        ],
      ],

      link: [null,
        [
          Validators.required
        ],
      ],

      quantity: [null,
        [
          Validators.required
        ],
      ],
      itemPrice: [null,
        [
          Validators.required
        ],
      ],

      weight: [null,
        [
          Validators.required,
          Validators.min(1)
        ],
      ],

      buyerId: [''],

      type: [null],
      color: [null],
      size: [null],
      note: [null],
      employeeId: [1],

      expressShipping: [false],
      insurance: [false],

      couponPercentage: [0],
      couponName: [''],
      discount: [0],

      extraFee: [0],
      noteFroExtraFee: [''],

      height: [0],
      width: [0],
      length: [0]
    });





  }

  openClassToggle(): boolean {
    return (this._openClassToggle = !this._openClassToggle);
  }

  toggleNewOrder() {
    this.openWebsite = false;
    this.openNewOrder = true;
    this.openOrders = false;
    this._openClassToggle = false;
  }


  toggleOrders() {
    this.openWebsite = false;
    this.openNewOrder = false;
    this.openOrders = true;
    this._openClassToggle = false;


  }


  switchPage(event: PageEvent, searchQuery: string = "") {

    var buyer: IUser = JSON.parse(localStorage.getItem("user"));
    if (!buyer) {
      this.toastrService.info("Please Login");
      return;
    }

    this.pagination = {
      currentPage: event.pageIndex + 1,
      pageSize: event.pageSize,
      buyerId: buyer.id,

    };

    this._shippingService.searchShipping(this.pagination).subscribe();

    this.shippings$.subscribe((data) => {
      this.totalCount = data.pagination.totalCount;
      this.pagination = data.pagination;
    })

  }









  onSumbitForm(data: IShipping) {


    let user: IUser = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      this._toastrService.warning('Login');
      return;
    }

    if (!this.onlineShoppingForm.valid) {
      this._toastrService.warning('Form is invalid');
    }



    data.userId = data.userId;
    data.buyerId = user.id.toString();
    this.onlineShoppingForm.get('buyerId').setValue(user.id.toString());


    let formData = new FormData();



    formData.append('productName', this.onlineShoppingForm.value.productName);
    formData.append('link', this.onlineShoppingForm.value.link);
    formData.append('quantity', this.onlineShoppingForm.value.quantity);
    formData.append('itemPrice', this.onlineShoppingForm.value.itemPrice);
    formData.append('weight', this.onlineShoppingForm.value.weight);
    formData.append('buyerId', user.id);
    formData.append('userId', user.id);
    formData.append('type', this.onlineShoppingForm.value.type);
    formData.append('color', this.onlineShoppingForm.value.color);
    formData.append('size', this.onlineShoppingForm.value.size);
    formData.append('note', this.onlineShoppingForm.value.note);
    formData.append('employeeId', this.onlineShoppingForm.value.employeeId);
    formData.append('expressShipping', this.onlineShoppingForm.value.expressShipping);
    formData.append('insurance', this.onlineShoppingForm.value.insurance);
    formData.append('insurance', this.onlineShoppingForm.value.insurance);
    formData.append('couponPercentage', this.onlineShoppingForm.value.couponPercentage);
    formData.append('couponName', this.onlineShoppingForm.value.couponName);
    formData.append('discount', this.onlineShoppingForm.value.discount);

    formData.append('extraFee', this.onlineShoppingForm.value.extraFee);
    formData.append('noteFroExtraFee', this.onlineShoppingForm.value.noteFroExtraFee);
    formData.append('height', this.onlineShoppingForm.value.height);
    formData.append('width', this.onlineShoppingForm.value.width);
    formData.append('length', this.onlineShoppingForm.value.length);
    formData.append('ContactBy', 'website');
    formData.append('ShippingStatus', '1');


    if (this.productImages.length > 0) {
      for (let i = 0; i < this.productImages.length; i++) {

        formData.append('ImageFile', this.productImages[i]);
      }
    }



    this._shippingService.addShipping(formData).subscribe({
      next: (data: IIndexShipping) => {
        this._toastrService.success('Add Successfly');

        this.onlineShoppingForm.reset();
        this._router.navigateByUrl(`/shop/onlineMarket/${data.buyerId}/${data.shippingId}`);

      },
      error: (error) => { },
      complete: () => { },
    })

  }


  shippingStatus(status: number) {
    switch (status) {
      case 1:
        return 'Request';
      case 2:
        return 'Return';
      case 3:
        return 'Canceled';
      case 4:
        return 'Approved';
      case 5:
        return 'Purchased';
      case 6:
        return 'ArrivedToErbil';
      case 7:
        return 'Sent';
      case 8:
        return 'Delivered';
      default:
        break;
    }
  }

  statusColor(status: number) {
    switch (status) {
      case 1:
        return '';
      case 2:
        return '#03C6F3';
        return 'Reviewing';
      case 3:
        return '#E12E19';
        return 'Canceled';
      case 4:
        return '#003BF9';
        return 'Approved';
      case 5:
        return '#9B00FF';
        return 'Purchased';
      case 6:
        return '#F9ED00';
        return 'ArrivedToUSWarehouse';
      case 7:
        return '#00FE29';
        return 'IntShipping';
      case 8:
        return '#849987';
        return 'ArrivedToErbil';
      case 9:
        return '#066D15';
        return 'Delivered';

    }
  }

  sortByStatus() {
    var buyer: IUser = JSON.parse(localStorage.getItem("user"));
    if (!buyer) {
      this.toastrService.info("Please Login");
      return;
    }

    this.orderBy = this.orderBy == 'ShippingStatus' ? 'ShippingStatus desc' : 'ShippingStatus';
    this.pagination = {
      currentPage: 1,
      pageSize: 24,
      buyerId: buyer.id,
      orderBy: this.orderBy

    };

    this._shippingService.searchShipping(this.pagination).subscribe();
    this.shippings$.subscribe((data) => {
      this.totalCount = data.pagination.totalCount;
      this.pagination = data.pagination;
    })
  }



  fromDateEvent(event: any) {


    var user: IUser = JSON.parse(localStorage.getItem('user'));

    this.startDate = event.target.value;
    this.pagination = {
      currentPage: 1,
      pageSize: 24,
      fromDate: this.datePipe.transform(this.startDate, 'MM/dd/yyyy'),
      toDate: this.datePipe.transform(this.endDate, 'MM/dd/yyyy'),
      buyerId: user.id
    };


    this._shippingService.searchShipping(this.pagination).subscribe();
  }

  toDateEvent(event: any) {

    this.endDate = event.target.value;
    var user: IUser = JSON.parse(localStorage.getItem('user'));
    this.pagination = {
      currentPage: 1,
      pageSize: 24,
      fromDate: this.datePipe.transform(this.startDate, 'MM/dd/yyyy'),
      toDate: this.datePipe.transform(this.endDate, 'MM/dd/yyyy'),
      buyerId: user.id

    };


    this._shippingService.searchShipping(this.pagination).subscribe();
  }


  onFileSelected(event) {
    if (event.target.files.length < 1) {
      return;
    }
    // const imagesFromArray = <FormArray>this.productForm.controls.images;
    this.imagesUrls = [];
    for (let i = 0; i < event.target.files.length; i++) {
      const ImageFile = event.target.files[i];
      console.log(ImageFile.name);

      // imagesFromArray.push(new FormControl({ImageFile}));
      this.productImages.push(ImageFile);

      const reader = new FileReader();
      reader.readAsDataURL(ImageFile);
      reader.onload = (event: any) => {
        this.imagesUrls.push(event.target.result);
      };
    }
  }



  applyCoupon(couponName: string) {

    if (this.isCouponApplied) {
      var couponInputValue = this.couponInput.nativeElement.value;
      this.onCouponBlur(null);
      this.isCouponApplied = false;
      this.disabled();
      this.onlineShoppingForm.get("couponPercentage").setValue(0);
      this.onlineShoppingForm.get("couponPercentage").setValue("");
      this.usedCouponName = "";
      this.couponInput.nativeElement.value = "";
      this.couponInput.nativeElement.disabled = false;

      return;
    }
    if (!couponName) {
      this.onlineShoppingForm.get("couponPercentage").setValue(0);
      this.onlineShoppingForm.get("couponName").setValue("");
      return;
    }

    if (this.usedCouponName === couponName) {
      this._toastrService.info(`You already applied this coupon.`);
      return;
    }
    this._orderService.couponByName(couponName).subscribe({
      next: (coupon: IIndexCoupon) => {

        if (coupon) {

          if (coupon.isExpired) {
            this._toastrService.warning(`This coupon is expired.`);
            return;
          }

          if (!coupon.isAvailable) {
            this._toastrService.info(`This coupon is not available.`);
            return;
          }

          if (
            this.isCouponApplied &&
            coupon.couponName === this.usedCouponName
          ) {
            this._toastrService.info(`You already applied this coupon.`);
            return;
          }

          this.isCouponApplied = true;
          this.disabled();

          this.usedCouponName = couponName;
          this.onlineShoppingForm.get("couponPercentage").setValue(coupon.percentage);
          this.onlineShoppingForm.get("couponName").setValue(coupon.couponName + ' ' + coupon.percentage + '%');
          this._toastrService.success(
            `Successfully  %${coupon.percentage} applied.`
          );
          this.coupons$ = this._orderService.getCoupon$;

          // this.rewardInput.nativeElement.value = '';
          this.couponInput.nativeElement.disabled = true;
        }
      },
      error: (error) => {
        parseWebAPIErrors(error).forEach((e: any) => {
          this._toastrService.warning(e);
        });
        this.onlineShoppingForm.get("couponPercentage").setValue(0);
        this.onlineShoppingForm.get("couponName").setValue("");

      },
    });
  }

  onCouponBlur(value: string) {
    if (!value) {
      var couponInputValue = this.couponInput.nativeElement.value;
      if (couponInputValue.length <= 0) {
        this.isCouponApplied = false;
        this.disabled();
        this.onlineShoppingForm.get("couponPercentage").setValue(0);
        this.onlineShoppingForm.get("couponName").setValue("");
        this.usedCouponName = "";
      }
    }
  }

  disabled() {
    if (this.isCouponApplied) {
      this.couponDisabled = !this.isCouponApplied;

    }


    if (
      !this.isCouponApplied

    ) {
      this.couponDisabled = false;
    }
  }


  showCalculation() {
    this.showCalc = !this.showCalc;
  }

  onHeightInput(height: number) {
    if (height as number) {
      this.height = height;
      var weight = this.height * this.width * this.length / 145;
      weight = weight < 1 ? 1 : weight;
      this.onlineShoppingForm.get('height').setValue(height.toString())
      this.onlineShoppingForm.get('weight').setValue(weight.toString())
    }


  }
  onWidthInput(width) {
    if (width as number) {
      this.width = width;
      var weight = this.height * this.width * this.length / 145;
      weight = weight < 1 ? 1 : weight;
      this.onlineShoppingForm.get('width').setValue(width.toString())
      this.onlineShoppingForm.get('weight').setValue(weight.toString())
    }

  }
  onLengthInput(length) {
    if (length as number) {
      this.length = length;
      var weight = this.height * this.width * this.length / 145;
      weight = weight < 1 ? 1 : weight;
      this.onlineShoppingForm.get('length').setValue(length.toString())
      this.onlineShoppingForm.get('weight').setValue(weight.toString())
    }

  }

  toggleWebsites() {
    this.openWebsite = true;
    this.openNewOrder = false;
    this.openOrders = false;
    this._openClassToggle = false;
  }

  websiteName(webName: string): string {

    var firstWebNameDot = webName.indexOf('.');
    var lastWebNameDot = webName.lastIndexOf('.');
    var web = webName.substring(firstWebNameDot + 1, lastWebNameDot)
    return web;
  }

  openLink(webLink: string) {
    window.open(webLink, "_blank");
  }

  public onDisplayImage = (serverPath: string): string => {
    const imageApi = environment.imageApi;
    const result = `${imageApi}/${serverPath}`;

    return result;
  };

}
